import React, {Component} from 'react';
import ReactSlider from 'react-slider';
import InputText from 'components/atoms/inputs/input-text';

class SliderAdapter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.defaultValue,
        };
    }

    onAfterChange(value) {
        this.setState({value});

        const {onChange} = this.props;
        const currentValue = [];
        if (Array.isArray(value)) {
            currentValue.push(value[0]);
            currentValue.push(value[1]);
        } else {
            currentValue.push(Number(value));
        }

        onChange(currentValue);
    }

    onChange(value) {
        this.setState({value});
    }

    onBlurInput(inputValue) {
        const {min, max} = this.props;
        let value = Number(inputValue);

        if (value < min) {
            value = min;
        } else if (value > max) {
            value = max;
        }

        this.onAfterChange(value);
    }

    render() {
        const {
            min,
            max,
            step,
            minDistance = 0,
            thumb = <div className="circle"></div>,
            className = '',
            prependInput = false,
        } = this.props;

        return (
            <div className={`slider-holder ${className}`}>
                {prependInput && (
                    <InputText
                        className="input-sm"
                        percent
                        min={min}
                        max={max}
                        value={this.state.value}
                        onBlur={::this.onBlurInput}
                    />
                )}
                <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="slider-thumb"
                    trackClassName="slider-track"
                    onAfterChange={::this.onAfterChange}
                    onChange={::this.onChange}
                    min={min}
                    max={max}
                    value={this.state.value}
                    step={step}
                    minDistance={minDistance}
                />
            </div>
        );
    }
}

export default SliderAdapter;
